<template>
  <div class="roster-drawer__search can-not-drag-wrap">
    <div class="search-box">
      <i class="iconfont el-icon-search"></i>
      <el-input
        v-model="name"
        placeholder="请输入姓名"
        @input="handleSearch"
      ></el-input>
    </div>
    <div class="handle-box">
      <!-- 奖杯 -->
      <div class="handle-item">
        <img :src="batchTrophyImg" @click="handleBatchTrophy" alt="" />
      </div>
      <div class="handle-item">
        <!-- 全体开/闭麦 -->
        <el-tooltip
          class="item"
          effect="dark"
          :content="
            roomInfo.is_send_audio !== 1 ? '全部开麦克风' : '全部关麦克风'
          "
          :disabled="audioLoading"
          placement="top"
        >
          <img :src="batchMicImg" @click="handleBatchMic" alt="" />
        </el-tooltip>
      </div>
      <div class="handle-item" v-if="roomInfo.mode != 1">
        <!-- 全体开/闭摄像头 -->
        <el-tooltip
          class="item"
          effect="dark"
          :content="
            roomInfo.is_send_video !== 1 ? '全部开摄像头' : '全部关摄像头'
          "
          :disabled="videoLoading"
          placement="top"
        >
          <img :src="batchVideoImg" @click="handleBatchVideo" alt="" />
        </el-tooltip>
      </div>
      <div class="handle-item">
        <el-tooltip
          class="item"
          effect="dark"
          content="全部回到台下"
          placement="top"
        >
          <img
            @click="handleBatchStage()"
            src="@saas/pages/assets/images/live/step-down.png"
            alt=""
          />
        </el-tooltip>
      </div>
      <!-- 全体开/闭禁言 -->
      <div class="handle-item">
        <el-tooltip
          class="item"
          effect="dark"
          :content="roomInfo.is_send_msg !== 1 ? '全部取消禁言' : '全部禁言'"
          :disabled="messageLoading"
          placement="top"
        >
          <img :src="batchMessageImg" @click="handleBatchMessae" alt="" />
        </el-tooltip>
      </div>
      <!-- 上台权限设置 -->
      <div class="handle-item">
        <el-popover
          placement="bottom-start"
          trigger="hover"
          popper-class="mic-popover"
          :visible-arrow="false"
          :append-to-body="true"
          @show="getRoomInfo"
        >
          <div class="popover-content" ref="popoverContent">
            <div class="group-title">上台权限设置</div>
            <div class="divider"></div>
            <ul class="set-list">
              <li v-for="item in displaySetOptions" :key="item.value">
                <div class="label ellipsis">{{ item.label }}</div>

                <el-switch
                  v-if="item.value === 'camera'"
                  class="live-room-switch"
                  v-model="cameraPermission"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#165DFF"
                  inactive-color="#3F3F46"
                ></el-switch>
                <el-switch
                  v-else-if="item.value === 'mic'"
                  class="live-room-switch"
                  v-model="micPermission"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#165DFF"
                  inactive-color="#3F3F46"
                ></el-switch>
                <el-switch
                  v-else-if="item.value === 'whiteboard'"
                  class="live-room-switch"
                  v-model="whiteboardPermssion"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#165DFF"
                  inactive-color="#3F3F46"
                ></el-switch>
              </li>
            </ul>
          </div>
          <img
            slot="reference"
            src="@saas/pages/assets/images/live/set-icon.png"
            alt=""
          />
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
// loading图标
const LOADING_IMG = require("@saas/pages/assets/images/live/loading.png");
// 批量麦克风图标
const BATCH_MIC_OPEN_IMG = require("@saas/pages/assets/images/live/mic-close.png");
const BATCH_MIC_CLOSE_IMG = require("@saas/pages/assets/images/live/close-mic.png");
// 批量摄像头图标
const BATCH_VIDEO_OPEN_IMG = require("@saas/pages/assets/images/live/video-close.png");
const BATCH_VIDEO_CLOSE_IMG = require("@saas/pages/assets/images/live/close-video.png");
// 批量禁言图标
const BATCH_MESSAGE_OPEN_IMG = require("@saas/pages/assets/images/live/mute.png");
const BATCH_MESSAGE_CLOSE_IMG = require("@saas/pages/assets/images/live/close-mute.png");
// 批量奖杯图标
const BATCH_TROPHY_IMG = require("@saas/pages/assets/images/live/trophy-all.png");
import { mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import handleRemote from "../../mixins/handle-remote";
import { debounce } from "@saas/components/src/utils/debounce-async";
import { updateRoomStatus, getRoomInfo } from "@saas/server-api/src/live-sdk";

export default {
  mixins: [handleRemote],
  components: {},
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isElectron: window.isElectron,
      name: "",
      messageLoading: false,
      audioLoading: false,
      videoLoading: false,
      trophyLoading: false,
      batchUpdater: null,
      setOptions: [
        {
          label: "摄像头",
          value: "camera",
        },
        {
          label: "麦克风",
          value: "mic",
        },
        {
          label: "白板",
          value: "whiteboard",
        },
      ],
    };
  },
  computed: {
    ...mapState("live", ["roomInfo", "userStatus"]),
    displaySetOptions() {
      if (this.roomInfo.mode === 1) {
        return this.setOptions.filter((item) => item.value !== "camera");
      }
      return this.setOptions;
    },
    batchMicImg() {
      if (this.audioLoading) return LOADING_IMG;
      return this.roomInfo.is_send_audio !== 1
        ? BATCH_MIC_OPEN_IMG
        : BATCH_MIC_CLOSE_IMG;
    },
    batchVideoImg() {
      if (this.videoLoading) return LOADING_IMG;
      return this.roomInfo.is_send_video !== 1
        ? BATCH_VIDEO_OPEN_IMG
        : BATCH_VIDEO_CLOSE_IMG;
    },
    batchMessageImg() {
      if (this.messageLoading) return LOADING_IMG;
      return this.roomInfo.is_send_msg !== 1
        ? BATCH_MESSAGE_OPEN_IMG
        : BATCH_MESSAGE_CLOSE_IMG;
    },
    batchTrophyImg() {
      if (this.trophyLoading) return LOADING_IMG;
      return BATCH_TROPHY_IMG;
    },
    // 上台摄像头权限
    cameraPermission: {
      get() {
        return this.roomInfo.up_stage_video;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_video: value });
      },
    },
    // 上台麦克风权限
    micPermission: {
      get() {
        return this.roomInfo.up_stage_audio;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_audio: value });
      },
    },
    // 上台白板权限
    whiteboardPermssion: {
      get() {
        return this.roomInfo.up_stage_whiteboard;
      },
      set(value) {
        this.updateRoomStatus({ up_stage_whiteboard: value });
      },
    },
  },
  watch: {},
  created() {},
  methods: {
    ...mapMutations("live", [
      "setRoomInfo",
      "setUserStatus",
      "setShowRoster",
      "setShowChangeNickname",
    ]),
    handleSearch: debounce(function () {
      this.$emit("search", this.name);
    }, 500),
    // 操作全体麦克风
    handleBatchMic: debounce(
      function () {
        const type = this.roomInfo.is_send_audio !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体麦克风" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_mic",
            type: type,
          },
        });
        this.audioLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteAudio(status)
          .then((res) => {
            this.audioLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体麦克风" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_mic",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.audioLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体麦克风" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_mic",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),
    // 操作全体摄像头
    handleBatchVideo: debounce(
      function () {
        const type = this.roomInfo.is_send_video !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体摄像头" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_video",
            type: type,
          },
        });
        this.videoLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteVideo(status)
          .then((res) => {
            this.videoLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体摄像头" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_video",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.videoLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体摄像头" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_video",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),
    // 全体下台
    handleBatchStage: debounce(function () {
      uploadLiveLog({
        message: "用户点击全体下台",
        level: "info",
        tag: "userAction",
        extra: {
          component: "Roster",
          action: "click_roster_batch_stage",
        },
      });
      this.handleAllRemoteDownStage()
        .then(() => {
          uploadLiveLog({
            message: "用户点击全体下台成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_stage",
            },
          });
        })
        .catch((err) => {
          uploadLiveLog({
            message: "用户点击全体下台失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_stage",
              error: err?.message || err,
            },
          });
        });
    }, 300),
    // 操作全体消息 禁言/解除禁言
    handleBatchMessae: debounce(
      function () {
        const type = this.roomInfo.is_send_msg !== 1 ? "open" : "close";
        uploadLiveLog({
          message: "用户点击全体消息" + (type === "open" ? "打开" : "关闭"),
          level: "info",
          tag: "userAction",
          extra: {
            component: "Roster",
            action: "click_roster_batch_message",
            type: type,
          },
        });
        this.messageLoading = true;
        const status = type === "open" ? 1 : 2;
        this.handleAllRemoteMessage(status)
          .then((res) => {
            this.messageLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体消息" +
                (type === "open" ? "打开" : "关闭") +
                "成功",
              level: "info",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_message",
                type: type,
              },
            });
          })
          .catch((err) => {
            this.messageLoading = false;
            uploadLiveLog({
              message:
                "用户点击全体消息" +
                (type === "open" ? "打开" : "关闭") +
                "失败",
              level: "error",
              tag: "userAction",
              extra: {
                component: "Roster",
                action: "click_roster_batch_message",
                type: type,
                error: err?.message || err,
              },
            });
          });
      },
      300,
      true
    ),
    // 操作全体奖杯
    handleBatchTrophy: debounce(function () {
      // 判断是否有在线学生
      const isHaveOnlineStudent = this.list.findIndex(
        (item) => item.status === 1 && item.user_role === 3
      );
      if (isHaveOnlineStudent === -1) {
        this.$darkMessage.error("没有在线学生，无法操作");
        return;
      }
      uploadLiveLog({
        message: "用户点击全体奖杯",
        level: "info",
        tag: "userAction",
        extra: {
          component: "Roster",
          action: "click_roster_batch_trophy",
        },
      });
      this.trophyLoading = true;
      this.handleAwardTrophy("*")
        .then((res) => {
          this.trophyLoading = false;
          uploadLiveLog({
            message: "用户点击全体奖杯成功",
            level: "info",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_trophy",
            },
          });
        })
        .catch((err) => {
          this.trophyLoading = false;
          uploadLiveLog({
            message: "用户点击全体奖杯失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "Roster",
              action: "click_roster_batch_trophy",
              error: err?.message || err,
            },
          });
        });
    }, 300),
    // 更改房间状态
    updateRoomStatus(params) {
      updateRoomStatus({
        id: this.roomInfo.id,
        ...params,
      }).then((res) => {
        if (res.code === 1) {
          this.setRoomInfo(params);
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    async getRoomInfo() {
      let { code, data, message } = await getRoomInfo({
        room_id: this.roomInfo.id,
      });
      if (code === 1) {
        this.setRoomInfo(data || {});
      } else {
        this.$darkMessage.error(message);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.roster-drawer__search ::v-deep {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #27272a;
  height: 64px;
  .search-box {
    width: 210px;
    height: 32px;
    background: #27272a;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    i {
      font-size: 17px;
      color: #a1a1aa;
    }
    .el-input {
      border: none;
      height: 100%;
      .el-input__inner {
        height: 100%;
        background: transparent;
        border: none;
        color: #c9cdd4;
        padding: 0 4px;
      }
    }
  }
  .handle-box {
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
  .handle-item {
    display: flex;
  }
}

.popover-content {
  .group-title {
    font-weight: 400;
    font-size: 12px;
    color: #86909c;
  }
  .set-list {
    list-style: none;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      font-size: 14px;
      color: #c9cdd4;
      line-height: 24px;
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
  }

  .divider {
    height: 1px;
    background: #27272a;
    border-radius: 0px 0px 0px 0px;

    margin: 12px 0;
  }
}
</style>
<style>
.mic-popover {
  width: 170px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #27272a;
  padding: 12px;
}
</style>
